import { defineComponent as _defineComponent } from 'vue'
import {
  ContentDisplay,
  HeadingDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import {
  IWallet,
  IRisk
} from '@/modules/wealth/services/suggested-portfolio-builder';

interface Props {
  portfolio: IWallet;
}

interface EmitEvents {
  (event: 'click', value: IWallet): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioSelectionBox',
  props: {
    portfolio: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click', value: IWallet): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolio: IWallet;
}





function computedColorStyle(risk: string) {
  let color = '';

  switch (risk) {
    case IRisk.LOW:
      color = NebraskaColors.riskLow;
      break;

    case IRisk.MEDIUM:
      color = NebraskaColors.riskMedium;
      break;

    case IRisk.HIGH:
      color = NebraskaColors.riskMedium;
      break;

    default:
      color = 'none';
      break;
  }

  return {
    borderLeft: `5px solid ${color}`
  };
}

function emitClick() {
  emit('click', props.portfolio);
}

return { __sfc: true,emit, props, computedColorStyle, emitClick, ContentDisplay, HeadingDisplay, ListDisplay }
}

})